<template>

<com-item name="game.streaks" :size="size" :loading="loading" :is-empty="!active" :any-height="true" :has-more="hasMore" v-on:more="onMore" title="Streaks">

	<template v-slot:about>

		<p>Consecutive months with or without playing this game.</p>

	</template>

	<template v-slot:stats>

		<div class="streaks" v-if="active">

			<div class="streaks-highlights">

				<div class="streaks-highlight" v-for="(item, index) in streakHighlights" :key="index">

					<div class="streaks-highlight-head">

						<div class="streaks-highlight-label">{{ item.label }}</div>

						<div class="streaks-highlight-pill" :class="'is-' + item.theme">{{ item.pill }}</div>

					</div>

					<div class="streaks-highlight-value">

						<div class="streaks-highlight-count">{{ item.value }}<small>{{ item.unit }}</small></div>

						<div class="streaks-highlight-range" v-if="item.range">{{ item.range }}</div>

					</div>

					<div class="streaks-highlight-bar" v-if="item.bar">

						<div class="streaks-highlight-bar-fill" :class="'is-' + item.theme" :style="{ width: item.bar + '%' }" />

					</div>

				</div>

			</div>

			<div class="streaks-timeline" v-if="timeline.length">

				<div class="streaks-timeline-bar">

					<div class="streaks-timeline-segment" v-for="(seg, index) in timeline" :key="index" :class="'is-' + seg.type" :style="{ width: seg.width + '%' }" v-tooltip="seg.tooltip" />

				</div>

				<div class="streaks-timeline-labels">

					<div class="streaks-timeline-label">{{ timelineStart }}</div>
					<div class="streaks-timeline-label">Now</div>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/game/plays']

		},

		current: function() {

			return (this.data && this.data.current) ? this.data.current : null

		},

		longestPlayed: function() {

			return (this.data && this.data.longestPlayed) ? this.data.longestPlayed : null

		},

		longestUnplayed: function() {

			return (this.data && this.data.longestUnplayed) ? this.data.longestUnplayed : null

		},

		timeline: function() {

			if (!this.data || !this.data.timeline || !this.data.timeline.length) return []

			var total = 0

			this.data.timeline.forEach(function(s) { total += s.months })

			return this.data.timeline.map(function(s) {

				return {
					type: s.type,
					width: (s.months / total) * 100,
					tooltip: s.months + ' month' + (s.months === 1 ? '' : 's') + ' ' + s.type
				}

			})

		},

		timelineStart: function() {

			return (this.data && this.data.timelineStart) ? this.data.timelineStart : ''

		},

		maxMonths: function() {

			var max = 0

			if (this.current && this.current.months > max) max = this.current.months
			if (this.longestPlayed && this.longestPlayed.months > max) max = this.longestPlayed.months
			if (this.longestUnplayed && this.longestUnplayed.months > max) max = this.longestUnplayed.months

			return max

		},

		streakHighlights: function() {

			if (!this.active) return []

			var items = []
			var max = this.maxMonths

			if (this.current) {

				items.push({
					pill: this.current.type === 'played' ? 'Hot' : 'Cold',
					theme: this.current.type === 'played' ? 'hot' : 'cold',
					label: 'Current Streak',
					value: this.current.months,
					unit: this.current.months === 1 ? ' month' : ' months',
					range: this.current.fromLabel + ' — now',
					bar: max ? Math.round((this.current.months / max) * 100) : 0
				})

			}

			var currentIsLongestPlayed = this.current && this.longestPlayed && this.current.type === 'played' && this.current.months === this.longestPlayed.months && this.current.fromLabel === this.longestPlayed.fromLabel
			var currentIsLongestUnplayed = this.current && this.longestUnplayed && this.current.type === 'unplayed' && this.current.months === this.longestUnplayed.months && this.current.fromLabel === this.longestUnplayed.fromLabel

			if (this.longestPlayed && !currentIsLongestPlayed) {

				items.push({
					pill: 'Hot',
					theme: 'hot',
					label: 'Longest Hot',
					value: this.longestPlayed.months,
					unit: this.longestPlayed.months === 1 ? ' month' : ' months',
					range: this.longestPlayed.fromLabel + ' — ' + this.longestPlayed.toLabel,
					bar: max ? Math.round((this.longestPlayed.months / max) * 100) : 0
				})

			}

			if (this.longestUnplayed && !currentIsLongestUnplayed) {

				items.push({
					pill: 'Cold',
					theme: 'cold',
					label: 'Longest Cold',
					value: this.longestUnplayed.months,
					unit: this.longestUnplayed.months === 1 ? ' month' : ' months',
					range: this.longestUnplayed.fromLabel + ' — ' + this.longestUnplayed.toLabel,
					bar: max ? Math.round((this.longestUnplayed.months / max) * 100) : 0
				})

			}

			return items

		},

		hasMore: function() {

			return this.data && this.data.streaksTotal > 3

		},

		active: function() {

			return this.current && !this.loading

		}

	},

	methods: {

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameStreaks',
				id: parseInt(this.$route.params.game) || 0
			})

		}

	}

}

</script>

<style scoped>

.streaks {
	width: 100%;
}

.streaks-highlights {
	display: flex;
	flex-direction: column;
}

.streaks-highlight {
	display: flex;
	flex-direction: column;
	gap: 6px;
	padding: 10px 15px;
}

.streaks-highlight:nth-child(odd) {
	background-color: rgba(12, 137, 178, 0.05);
}

.streaks-highlight-head {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
}

.streaks-highlight-pill {
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	padding: 2px 8px;
	border-radius: 10px;
	line-height: 16px;
	flex-shrink: 0;
}

.streaks-highlight-pill.is-hot {
	background-color: rgba(223, 71, 81, 0.12);
	color: #c0392b;
}

.streaks-highlight-pill.is-cold {
	background-color: rgba(72, 129, 187, 0.12);
	color: #4881bb;
}

.streaks-highlight-label {
	font-size: 12px;
	font-weight: 500;
	color: #333;
	flex-grow: 1;
}

.streaks-highlight-value {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	justify-content: space-between;
	gap: 8px;
}

.streaks-highlight-count {
	font-size: 28px;
	font-weight: 700;
	color: #333;
	line-height: 1;
}

.streaks-highlight-count small {
	font-size: 13px;
	font-weight: 400;
	color: #999;
}

.streaks-highlight-range {
	font-size: 12px;
	color: #999;
	font-weight: 400;
}

.streaks-highlight-bar {
	width: 100%;
	height: 6px;
	background-color: rgba(0, 0, 0, 0.04);
	border-radius: 3px;
	overflow: hidden;
}

.streaks-highlight-bar-fill {
	height: 100%;
	border-radius: 3px;
	transition: width 0.6s ease;
}

.streaks-highlight-bar-fill.is-hot {
	background-color: #4881bb;
}

.streaks-highlight-bar-fill.is-cold {
	background-color: #ccc;
}

.streaks-timeline {
	margin-top: 4px;
	padding: 12px 15px 10px;
}

.streaks-timeline-bar {
	display: flex;
	flex-direction: row;
	height: 20px;
	border-radius: 4px;
	overflow: hidden;
	gap: 1px;
}

.streaks-timeline-segment {
	height: 100%;
	min-width: 2px;
	transition: opacity 0.2s;
}

.streaks-timeline-segment.is-played {
	background-color: #4881bb;
}

.streaks-timeline-segment.is-unplayed {
	background-color: #e8e8e8;
}

.streaks-timeline-segment:hover {
	opacity: 0.7;
}

.streaks-timeline-labels {
	display: flex;
	justify-content: space-between;
	margin-top: 4px;
}

.streaks-timeline-label {
	font-size: 12px;
	color: #999;
	font-weight: 400;
}

</style>
